module.exports = __webpack_public_path__ + "fonts/RenaultLife-LightItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-LightItalic.woff
// module id = 364
// module chunks = 0